export function openPartnerLink(url?: string): void {
  if (!url || url === '#') {
    return;
  }

  window.open(url, '_blank', 'noopener,noreferrer');
}
